import { render, staticRenderFns } from "./RequestEvent.vue?vue&type=template&id=15fbf389"
import script from "./js/requestEvent.js?vue&type=script&lang=js&external"
export * from "./js/requestEvent.js?vue&type=script&lang=js&external"
import style0 from "./RequestEvent.vue?vue&type=style&index=0&id=15fbf389&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports